import httpClient from './httpClient';

const getData = (response) => {
    return response.data;
};

const request = {
    get(url, params = {}, requestConfig = {}) {
        return httpClient
            .get(url, {
                ...requestConfig,
                params,
            })
            .then(getData);
    },

    post(url, data = {}, requestConfig = {}) {
        return httpClient
            .post(url, data, requestConfig)
            .then(getData);
    },

    postFile(url, data, requestConfig = {}) {
        return httpClient
            .post(url, data, {
                ...requestConfig,
                headers: {
                    ...requestConfig.headers,

                    /*
                     * Böngészőben nem kötelező kézzel megadni a
                     * multipart/form-data értéket, mert az Axios beállítja
                     * a boundary paraméterrel együtt.
                     */
                },
            })
            .then(getData);
    },

    put(url, data = {}, requestConfig = {}) {
        return httpClient
            .put(url, data, requestConfig)
            .then(getData);
    },

    patch(url, data = {}, requestConfig = {}) {
        return httpClient
            .patch(url, data, requestConfig)
            .then(getData);
    },

    delete(url, data = null, requestConfig = {}) {
        return httpClient
            .delete(url, {
                ...requestConfig,
                data,
            })
            .then(getData);
    },

    download(url, params = {}) {
        return httpClient.get(url, {
            params,
            responseType: 'blob',
        });
    },
};

export default request;


// WEBPACK FOOTER //
// ./src/api/request.js